import Game from "./scenes/Game";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [Game],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: Game.KEY,

    started: false,

    makeData: {shapeUI:"",frostingUI:"",sprinkleUI:"",sprinkleCUI:"",eat:false,selected:{shape:"Ring"},sprinkle:false,index:0},

    currentDonuts: [],

    dots: [],

    sprinkleNums:{Jimmy:0,Dot:0,Star:0,Heart:0,arr:[1,2,3]},

    donutScale: .67,

    questionNum: 0,

    selectorDonut:[],

    clickedState: 0,

    colors: [
        "Brown",
        "Blue",
        "Lavender",
        "LightBlue",
        "Pink",
        "Purple",
        ],

    allColors: [
        "Black",
        "Blue",
        "Brown",
        "Green",
        "Lavender",
        "LightBlue",
        "Orange",
        "Pink",
        "Purple",
        "Red",
        "Teal",
        "Yellow"
        ],
    
    colorsHex:{
        Black:0x42332e,
        Pink:0xf06ba8,
        Purple:0xc63edd,
        Lavender:0xbf92f4,
        LightBlue:0x92c5f7,
        Blue:0x11b3b7,
        Teal:0x3ee58d,
        Green:0x5fd31c,
        Yellow:0xedbf00,
        Orange:0xea8500,
        Red:0xea341c,
        Brown:0x702b16
        },

    shapes: ["Heart","Ring","Round","Square","Star","Triangle"],

    questionText:{
        differ:"Which donut has a different",
        same:"Which two donuts are the same",
        shape:" shape?",
        color:" color?",
        shapeColor:" shape and color?"
    },

    makeDoText:[
        "Choose a donut shape:",
        "Pick a frosting color:",
        "Pick a sprinkle shape:",
        "Pick a sprinkle color:",
        "This donut looks yummy.\nClick to eat it up!"
    ],

    layouts:[],

    sizeMap:"",

}
